export function isStringWithLength(
  s: unknown,
  minLength: number = 1
): s is string {
  return typeof s === 'string' && s.length >= minLength
}

export function abbreviate(name: string) {
  const nameParts = name.split(' ')
  const initials =
    nameParts.length > 1
      ? `${nameParts[0][0]}${nameParts[1][0]}`
      : '??'
  return {
    initials,
  }
}

export function strToColor(s: string) {
  let hash = 0
  let i

   
  for (i = 0; i < s.length; i += 1) {
    hash = s.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.substr(-2)
  }
   

  return color
}
